import React, { useState, useEffect } from "react";
import { Offcanvas, Button } from "react-bootstrap";
import SidebarProducts from "../../components/pgi/SidebarProducts";
import { DisplaySettingsOutlined, ErrorOutline } from "@mui/icons-material";
import useProduct from "../../hooks/useProduct";
import ProductsReplicaPgi from "./editComponents/ProductsReplicaPgi";
import toast from "react-hot-toast";
import useAudit from "../../hooks/useAudit";
import { useDragDrop } from "../../hooks/useDragDrop";
import ListTableProducts from "../../components/pgi/ListTableProducts";
import { sortAndFilterProducts } from "../../helpers/functions";
import { PRODUCTO_ESPECIAL, PRODUCTO_LINEA } from "../../helpers/constants";

const ProductosPgi = () => {
  const {
    products,
    handleVisibility,
    handleProductUpdate,
    getAllProducts,
  } = useProduct();
  const { createAuditRequest } = useAudit();
  const [showEditProducto, setShowEditProducto] = useState(true);
  const [titleProduct, setTitleProduct] = useState("Tejalite");
  const handleClose = () => setShowEditProducto(false);
  const handleShow = () => setShowEditProducto(true);
  const [idProduct, setIdProduct] = useState(null);

  const user = JSON.parse(localStorage.getItem("Usuario"))?.UserLogin?.name;

  useEffect(() => {
    getAllProducts({ onlyTitleAndIcon: false });
    document.title = "Productos | PGI Tensolite";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDelete = (id) => {
    const toastId = toast(
      <div className="flex-column">
        <div className="text-center error_icon">
          <ErrorOutline />
        </div>
        <div className="text-center my-2">
          ¿Estas seguro de eliminar este producto?
        </div>
        <div className="d-flex justify-content-around">
          <Button
            className="w-40 button_error"
            variant="danger"
            onClick={() => handleConfirmDelete(id, "DELETE")}
          >
            Si
          </Button>
          <Button
            className="w-40 button_error"
            variant="secondary"
            onClick={() => toast.dismiss(toastId)}
          >
            No
          </Button>
        </div>
      </div>,
      {
        duration: 20000,
      }
    );
  };

  const handleConfirmDelete = (id) => {
    const productDelete = products?.find((prod) => prod._id === id && prod);
    createAuditRequest(
      {
        ...productDelete,
        element: 2,
        deleted: true,
        creator: user,
        imageBackground: [],
        imageBackground_tablet: [],
        imageBackground_mobile: [],
        imageProduct: [],
        imageProductAlpha: [],
        imageInstallation: [],
        imageLogo: [],
        imageLogoColor: [],
        imageIcon: [],
        imageIconColor: [],
        imageGallery: [],
        imageCarousel: [],
        imageCarouselHover: [],
      },
      "DELETE"
    );
    toast.dismiss();
  };

  const handleClickSidebar = (product) => {
    setTitleProduct(product?.title);
    setIdProduct(product?._id);
  };

  return (
    <div id="wrapperEditProducts" className="wrapperPgi">
      <button onClick={handleShow} className="basePgi__setttings-button">
        <DisplaySettingsOutlined />
      </button>
      <div className="card container containerPgi pt-3 pb-3">
        {idProduct !== null ? (
          <ProductsReplicaPgi
            idProduct={idProduct}
            titleProduct={titleProduct}
          />
        ) : null}
      </div>

      {/* OFFCANVAS SETTING HOME*/}
      <Offcanvas
        show={showEditProducto}
        onHide={handleClose}
        placement="start"
        scroll
        enforceFocus
        backdrop={false}
        className="basePgi__pgi"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>EDITAR PRODUCTOS</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form id="formEditarHSlider" className="basePgi__vista-edit-gral">
            <header aria-labelledby="formEditarHSlider">
              <div>
                <h2>Productos de Línea</h2>
                <p className="basePgi__comments">
                  Para acceder a los <strong>SUBPRODUCTOS</strong> debemos hacer
                  click en el nombre del Producto de Linea
                </p>
              </div>
              <SidebarProducts />
            </header>

            <ListTableProducts
              products={sortAndFilterProducts(products, PRODUCTO_LINEA)}
              productsEspecial={sortAndFilterProducts(products, PRODUCTO_ESPECIAL)}
              titleProduct={titleProduct}
              handleClickSidebar={handleClickSidebar}
              handleVisibility={handleVisibility}
              handleDelete={handleDelete}
            />

            <header aria-labelledby="formEditarHSlider">
              <div className="mt-3">
                <h2>Productos Especiales</h2>
              </div>
            </header>
            <ListTableProducts
              products={sortAndFilterProducts(products, PRODUCTO_ESPECIAL)}
              productsLinea={sortAndFilterProducts(products, PRODUCTO_LINEA)}
              titleProduct={titleProduct}
              handleClickSidebar={handleClickSidebar}
              handleVisibility={handleVisibility}
              handleDelete={handleDelete}
            />
            <button
              type="button"
              className="settings_button-pleno"
              onClick={handleProductUpdate}
            >
              Actualizar productos
            </button>
          </form>

        </Offcanvas.Body>
      </Offcanvas>
      {/*offC slides */}
    </div>
  );
};

export default ProductosPgi;
